import { useEffect, useState } from 'react'
import { useToken } from './useToken'

export function useGet<T>(initial: T, getFn: () => Promise<T>) {
  const [state, setState] = useState(initial)
  const { token } = useToken()
  function reload() {
    getFn().then(setState)
  }
  useEffect(reload, [token])
  return { state, setState, reload }
}
